var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2 slide-image transition-instruction-bar",class:{
    'has-bg-image': _vm.slideActive.backgroundImage,
    'has-caption': !_vm.slideActive.title || _vm.slideActive.title == ' ',
  }},[_c('div',{staticClass:"flex image-body"},[_c('div',{staticClass:"iframe-wrapper"},[_c('div',{staticClass:"youtube-player-wrap"}),_c('div',{staticClass:"youtube-iframe",attrs:{"id":_vm.videoId}})])]),(_vm.hasSlideActiveTitle)?_c('div',{staticClass:"p-0 caption",class:{
      'small-text': _vm.slideActive.title && _vm.slideActive.title.length > 64
    }},[_c('SlideTitleEditor',{staticClass:"p-0 youtube-caption-text",class:{'has-background': _vm.hasSlideActiveTitle},attrs:{"type":"slide-title"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }